import { useCallback } from "react";
import { Link } from "react-router";
import { CountCell } from "../../components/grid/cells/CountCell";
import { Toolbar } from "../../components/Toolbar";
import { AdministrateBackgroundExportButton } from "../components/AdministrateBackgroundExportButton";
import { AdministrateTable } from "../components/AdministrateTable";
import { SystemConfigLayout } from "../components/SystemConfigLayout";
import { Routes } from "../Routes";
import { DESTROY, makeColumns, useAdministrateTable, useCreatePermission } from "../utils";
import { AddCodeGroupModal } from "./components/AddCodeGroupModal";
import { ImportCodeGroupsModal } from "./components/ImportCodeGroupsModal";
import { CodeGroupActionCell } from "./components/CodeGroupActionCell";

const useColumns = makeColumns(() => [
  {
    id: "name",
    accessor: "name",
    Header: "Group Name",
    Cell: ({ row, value }) => <Link to={Routes.codeGroup.url(row.original.id)}>{value}</Link>,
  },
  {
    id: "cpt_codes.id",
    accessor: "cptCodeCount",
    Header: "CPT Codes",
    Cell: ({ value }) => <CountCell count={value} label="CPT Codes" />,
  },
  {
    id: "actions",
    Header: "Actions",
    Cell: CodeGroupActionCell,
    disableFilters: true,
    disableSortBy: true,
  },
]);

export const CodeGroupsIndexPage = () => {
  const columns = useColumns();
  const { tableRef, allFilters, setTableFilters } = useAdministrateTable();
  const [canCreate] = useCreatePermission("CodeGroup");

  const onImport = useCallback(
    (message, details = []) => {
      tableRef.current?.refresh?.();
      tableRef.current?.setMessage?.(message, details.length ? "warning" : "success", details);
    },
    [tableRef]
  );

  const onAdd = useCallback(
    (values) => {
      tableRef.current?.refresh?.();
      tableRef.current?.setMessage?.(`New Code Group "${values.name}" Added.`);
    },
    [tableRef]
  );

  return (
    <SystemConfigLayout title="Code Groups">
      <Toolbar className="align-items-center mb-3">
        <Toolbar className="ms-auto">
          <AdministrateBackgroundExportButton
            outline
            className="me-2"
            exportUrl="/admin/code_groups/export"
            filters={allFilters}
            ref={tableRef}
          />

          {canCreate && (
            <>
              <ImportCodeGroupsModal outline className="me-2" onImport={onImport} />
              <AddCodeGroupModal onAdd={onAdd} />
            </>
          )}
        </Toolbar>
      </Toolbar>

      <AdministrateTable
        resourceUrl={"/admin/code_groups.json"}
        resourceName={"code_group"}
        onFilteredChange={setTableFilters}
        permissions={[DESTROY]}
        columns={columns}
        ref={tableRef}
      />
    </SystemConfigLayout>
  );
};
